/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Pro_MonthlyInputs */

const en_plan_pro_monthly = /** @type {(inputs: Plan_Pro_MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro Monthly`)
};

const es_plan_pro_monthly = /** @type {(inputs: Plan_Pro_MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro Mensual`)
};

/**
* | output |
* | --- |
* | "Pro Monthly" |
*
* @param {Plan_Pro_MonthlyInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_pro_monthly = /** @type {((inputs?: Plan_Pro_MonthlyInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Pro_MonthlyInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_pro_monthly(inputs)
	return en_plan_pro_monthly(inputs)
});